class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.header = document.querySelector('.header-wrapper');

    // All nested details (inside content)
    this.innerDetails = this.content.querySelectorAll('details');

    // Prevent native click toggle
    this.setupSummaryClickPrevention();

    // Hover for main element
    this.setupHover(this.mainDetailsToggle, this.summary, this.content);

    // Hover for each inner <details>
    this.innerDetails.forEach((detailsEl) => {
      const innerSummary = detailsEl.querySelector('summary');
      const innerContent = innerSummary?.nextElementSibling;
      if (!innerSummary || !innerContent) return;

      this.setupHover(detailsEl, innerSummary, innerContent);
    });
  }

  setupSummaryClickPrevention() {
    this.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', (e) => {
        if (e.target.tagName.toLowerCase() === 'a') return;
        e.preventDefault();
      });
    });
  }

  setupHover(detailsEl, summaryEl, contentEl) {
    // Open on hover summary
    summaryEl.addEventListener("mouseenter", () => this.openDetails(detailsEl));

    // Keep open when hovering submenu
    contentEl.addEventListener("mouseenter", () => this.openDetails(detailsEl));

    // Close if leaving both
    const maybeClose = () => {
      setTimeout(() => {
        if (!summaryEl.matches(":hover") && !contentEl.matches(":hover")) {
          detailsEl.open = false;
        }
      }, 60);
    };

    summaryEl.addEventListener("mouseleave", maybeClose);
    contentEl.addEventListener("mouseleave", maybeClose);
  }

  openDetails(detailsEl) {
    detailsEl.open = true;

    // Only for main menu: update header position
    if (detailsEl === this.mainDetailsToggle && this.header) {
      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
        document.documentElement.style.setProperty(
          '--header-bottom-position-desktop',
          `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
        );
      }
    }
  }

  onToggle() {}
}

customElements.define("header-menu", HeaderMenu);

